import React from 'react';
import { Logo } from './Logo';
interface AuthCardProps {
  title: string;
  children: React.ReactNode;
  subtitle?: string;
}
export const AuthCard = ({
  title,
  children,
  subtitle
}: AuthCardProps) => {
  return <div className="min-h-screen flex items-center justify-center p-4" data-id="element-10">
      <div className="flex w-full max-w-4xl bg-white rounded-xl shadow-md overflow-hidden" data-id="element-11">
        <div className="hidden md:flex w-1/2 bg-primary-500 p-12 flex-col justify-center items-center" data-id="element-12">
          <div className="text-white" data-id="element-13">
            <div className="w-48 h-48 mx-auto mb-8 flex items-center justify-center" data-id="element-14">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/jwsrwc4ulmzfbdzuy8nr4q/3421766c-d8ad-4aaf-b6ec-936b0d30906e/image.png" alt="TailorPro" className="w-full h-full object-contain opacity-90" data-id="element-15" />
            </div>
            <h2 className="text-2xl font-bold text-center mb-2 text-gray-800" data-id="element-16">
              TailorPro
            </h2>
            <p className="text-center text-gray-700" data-id="element-17">
              Streamline your tailoring business with our comprehensive
              management system
            </p>
          </div>
        </div>
        <div className="w-full md:w-1/2 p-8" data-id="element-18">
          <div className="md:hidden mb-6 flex justify-center" data-id="element-19">
            <Logo data-id="element-20" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-21">{title}</h1>
          {subtitle && <p className="text-gray-500 mb-6" data-id="element-22">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>;
};